var __jsx = React.createElement;
import Loader from '@anm/components/Loader';
import useDelayedRender from '@anm/hooks/useDelayedRender';
import React from 'react';
import styled from 'styled-components';
var LoaderWrapper = styled(Loader).withConfig({
  componentId: "ie3pb0-0"
})(["flex-grow:0 !important;"]);

var DelayedLoader = function DelayedLoader() {
  var canRender = useDelayedRender(1000);
  if (!canRender) return null;
  return __jsx(LoaderWrapper, {
    size: "large",
    color: "blue"
  });
};

export default DelayedLoader;